<app-pane title="Animation">
  <div class="table">
    <div class="row">
      <div class="label-cell">Type</div>
      <div class="control-cell">
        <select #typeSelect [value]="type" (change)="typeChanged(typeSelect.value)">
          <option *ngFor="let type of types" [value]="type.id">{{type.name}}</option>
        </select>
      </div>
    </div>
    <div *ngIf="isState" class="row">
      <div class="label-cell">From state</div>
      <div class="control-cell">
        <select #fromStateSelect [value]="fromState" (change)="fromStateChanged(fromStateSelect.value)">
            <option *ngFor="let state of states" [value]="state.id">{{state.name}}</option>
          </select>
      </div>
    </div>
    <div *ngIf="isState" class="row">
      <div class="label-cell">To state</div>
      <div class="control-cell">
        <select #toStateSelect [value]="toState" (change)="toStateChanged(toStateSelect.value)">
            <option *ngFor="let state of states" [value]="state.id">{{state.name}}</option>
          </select>
      </div>
    </div>
    <div *ngIf="isState" class="row">
      <div class="label-cell">Skip by</div>
      <div class="control-cell">
        <app-slider-textbox #skipByControl [value]="skipBy" [min]="1" [max]="20" [integer]="true" (change)="skipByChanged(skipByControl.value)"></app-slider-textbox>
      </div>
    </div>
    <div *ngIf="isParticleTrace" class="row">
      <div class="label-cell">Num steps</div>
      <div class="control-cell">
        <app-slider-textbox #numStepsControl [value]="numSteps" [min]="10" [max]="1000" [integer]="true" (change)="numStepsChanged(numStepsControl.value)"></app-slider-textbox>
      </div>
    </div>
  </div>
  <div class="buttons-container">
    <button (click)="apply()">Apply</button>
    <button (click)="remove()">Remove</button>
  </div>
</app-pane>
